export default __webpack_public_path__ + "static/media/Q17_0_resized.7c9b5935.jpg";